
import {Component, ElementRef, inject, Input, OnChanges, SimpleChanges} from '@angular/core';
import { CommonModule } from '@angular/common';
import {EventManagerService} from "@wms/app";
import {filter} from "lodash-es";
import { CommonWidgetDirective } from "@wms/directives";


@Component({
  selector: 'wm-tab-order',
  standalone: true,
  imports: [CommonModule, CommonWidgetDirective],
  templateUrl: './wm-tab-order.component.html',
  styleUrls: ['./wm-tab-order.component.less']
})
export class WmTabOrderComponent implements OnChanges{
  private eventManager: EventManagerService;
  nativeElement:any
  @Input() activeWidget: any;

  constructor() {
    this.eventManager = inject(EventManagerService);
    const elementRef = inject(ElementRef);
    this.nativeElement = elementRef.nativeElement;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.showHideActions();
  }

  isVisible(indexValue: any) {
    if (this.activeWidget) {
      let widgetData = this.activeWidget.activeTab,
        currentWidgetPosition: any = this.getCurrentPosition(widgetData);

      if (indexValue === 1) {
        return currentWidgetPosition + 1 >= this.activeWidget.tabs.length ? 'hidden' : 'visible';
      }
      return currentWidgetPosition > 0 ? 'visible' : 'hidden';
    }
    return 'hidden';
  };

  getCurrentPosition(widgetData: any) {
    let currentWidgetPosition;
    this.activeWidget.tabs.forEach(function (value: any, index: any) {
      if (value.widgetId === widgetData.widgetId) {
        currentWidgetPosition = index;
      }
    });

    return currentWidgetPosition;
  };

  toggleActions(index: any) {
    let arrowUp = $(this.nativeElement).find('.arrowUp'),
      arrowDown = $(this.nativeElement).find('.arrowDown');
    arrowUp.css('visibility', 'visible');
    arrowDown.css('visibility', 'visible');
    if (index === (this.activeWidget.tabs.length - 1)) {
      if (index === 0) {
        arrowUp.css('visibility', 'hidden');
      }
      arrowDown.css('visibility', 'hidden');
    } else if (index === 0) {
      arrowUp.css('visibility', 'hidden');
    }
  };

  swapTabPanes = (nextWidgetPosition: number, currentWidgetPosition: number, indexValue: number) => {
    let eventman = this.eventManager
      eventman.emitOnCanvasMove({
        'parentId': this.activeWidget.widgetId,
        'widgetType': this.activeWidget.tabs[nextWidgetPosition].widgetType,
        'widgetId': this.activeWidget.tabs[nextWidgetPosition].widgetId,
        'referenceId': this.activeWidget.tabs[currentWidgetPosition].widgetId,
        'referencePos': indexValue === 1 ? 'after' : 'before',
        'isChildClickDisabled': true
      });
  }

  swapTabHeaders(nextWidgetPosition: any, currentWidgetPosition: any, headerEles: any, indexValue: any) {
    setTimeout(function () {
      let currentElement = headerEles.find('[data-tab-id=' + currentWidgetPosition + ']'),
        nextElement = headerEles.find('[data-tab-id=' + nextWidgetPosition + ']');
      currentElement.attr('data-tab-id', indexValue === -1 ? currentWidgetPosition - 1 : currentWidgetPosition + 1);
      nextElement.attr('data-tab-id', currentWidgetPosition);
      // currentElement.tabId = nextWidgetPosition;
      // nextElement.tabId    = currentWidgetPosition;
      if (indexValue === -1) {
        currentElement.insertBefore(nextElement);
      } else {
        currentElement.insertAfter(nextElement);
      }
    }, 0);
  }

  moveTab = (indexValue: number) => {
    let widgetData = this.activeWidget.activeTab,
      currentWidgetPosition: any = this.getCurrentPosition(widgetData),
      nextWidgetPosition = currentWidgetPosition + indexValue,
      parentId = this.activeWidget.widgetId,
      parentElement = $('[widgetId=' + parentId + ']'),
      $headerEles = parentElement.find('> .nav.nav-tabs'),
      tempWidget = this.activeWidget.tabs[currentWidgetPosition];

    this.activeWidget.tabs[currentWidgetPosition] = this.activeWidget.tabs[nextWidgetPosition];
    this.activeWidget.tabs[nextWidgetPosition] = tempWidget;
    this.swapTabPanes(nextWidgetPosition, currentWidgetPosition, indexValue);
    this.swapTabHeaders(nextWidgetPosition, currentWidgetPosition, $headerEles, indexValue);
    this.toggleActions(nextWidgetPosition);
  };
  showHideActions = () => {
    if (this.activeWidget) {
      let widgetData = filter(this.activeWidget.tabs, function (selectedTab) {
          return selectedTab.isActive === true;
        }),
        currentWidgetPosition = this.getCurrentPosition(widgetData[0] || this.activeWidget.tabs[0]);
      this.toggleActions(currentWidgetPosition);
    }
  };

}
